import React from 'react'
import { Button, Modal, Divider, Image } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import noEventImage from '../../../../../images/grafix-banner/gfx-event-deleted.svg'
class EventDetailsNotFound extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    handleClose = () => {
        dispatch.home.eventDetailsNotFound(false);
    }

    render() {

        return (
            <Modal
                size='small'
                open={this.props.open}
                centered
                className="basicModal"
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header >Event / Item Deleted</Modal.Header>
                <Divider />
                <Modal.Content style={{ textAlign: "center" }}>
                    <p>The event / item you are looking for has been deleted.</p>
                    <Image src={noEventImage} height={200} style={{ margin: "0 auto" }} />
                </Modal.Content>
                <Divider />
                <Modal.Actions>
                    <Button className="button-submit" id='cancelBtn' onClick={this.handleClose}> Ok</Button>
                </Modal.Actions>
            </Modal >
        )
    }
}

export default EventDetailsNotFound